import { useState, useEffect } from "react";
import { getItemNames } from "../../services/monday-service";
import logger from "../../lib/logger";

/**
 * Custom hook for fetching and managing item name
 */
export const useItemName = (itemIds: number[] | undefined) => {
  const [itemName, setItemName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchItemName = async (itemId: number[]) => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await getItemNames(itemId);

        if (response && response.length > 0) {
          setItemName(response[0].name);
        }
      } catch (error: any) {
        logger.error("Error fetching item name", error);
        setError(error.message || "Failed to fetch item name");
      } finally {
        setIsLoading(false);
      }
    };

    if (itemIds && itemIds.length > 0) {
      fetchItemName(itemIds);
    }
  }, [itemIds]);

  return { itemName, isLoading, error };
};

export default useItemName;
